import { FormControl } from '@mui/material';
import { Controller, useFormContext } from 'react-hook-form';
import { DatePicker } from '@mui/x-date-pickers-pro';
import { text } from '~/modules/@shared/helpers/text';
import {
  TakePaymentFormData,
  takePaymentFormDefault,
} from '~/modules/payment/components/TakePayment/helpers/TakePaymentSchema';
import dayjs from 'dayjs';

export default function PaymentDateField() {
  const {
    control,
    setValue,
    getValues,
    formState: { errors },
  } = useFormContext<TakePaymentFormData>();

  const handleBlur = (ev: any) => {
    if (dayjs(ev.target.value).isBefore(dayjs())) {
      setValue('scheduled_date', takePaymentFormDefault.scheduled_date);
    }
  };

  return (
    <Controller
      control={control}
      name="scheduled_date"
      render={({ field: { value, ...field } }) => (
        <FormControl fullWidth>
          <DatePicker
            {...field}
            onChange={(v) => {
              field.onChange(v?.format('YYYY-MM-DD'));
            }}
            value={value ? dayjs(value) : null}
            minDate={dayjs()}
            maxDate={getValues('isDea') ? undefined : dayjs()}
            slotProps={{
              textField: {
                error: !!errors.scheduled_date,
                helperText: text(errors.scheduled_date?.message),
                FormHelperTextProps: { error: true },
                placeholder: 'MM/DD/YYYY',
                onBlur: handleBlur,
              },
              inputAdornment: {
                position: 'start',
              },
            }}
          />
        </FormControl>
      )}
    />
  );
}
